import React from 'react';
import { UserModel } from 'services/EpdClient';
import styled from 'styled-components';

interface Props {
  user: UserModel;
}

const HeaderUserInfo: React.FC<Props> = ({ user }) => {
  const userRoles = user.roles.filter((r) => r.isDisplayedInMenu).map((r) => r.name);

  return (
    <Wrapper>
      <NameText>
        {user.firstName} {user.lastName}
      </NameText>
      {userRoles.length > 0 && <RoleText>{userRoles.join(', ')}</RoleText>}
    </Wrapper>
  );
};

export default HeaderUserInfo;

const Wrapper = styled.div`
  padding: 11px 16px;
`;

const NameText = styled.div`
  font-weight: 600;
`;

const RoleText = styled.div`
  color: ${(props) => props.theme.colors.primaryBlack70};
  margin-top: 8px;
`;
